import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { MatToolbar } from '@angular/material/toolbar';
import { MatMenu, MatMenuModule } from '@angular/material/menu';

// import { BackendApiService } from '../../../services/backend-api.service';
@Component({
  selector: 'app-manager-group-listing',
  templateUrl: './manager-group-listing.component.html',
  styleUrls: ['./manager-group-listing.component.scss'],
  standalone:true,
  imports:[MatToolbar,MatMenu,MatMenuModule]
})
export class ManagerGroupListingComponent implements OnInit {
  pid: boolean;
  showList: boolean;
  emptyMsg: boolean;
  checked = false;
  clientList = [
    {
      id: 12,
      full_name: 'Michael E Bomberger',
      email: 'jaydon_ledn@yahoo.com',
      used_license: 5,
      checked: false,
      total_license: 20,
      image: 'assets/images/alan.png'
    }, {
      id: 11,
      full_name: 'Carolyn J. Foy',
      email: 'CarolynJFoy@dayrep.com',
      used_license: 1,
      checked: false,
      total_license: 20,
      image: 'https://www.aero-mag.com/wp-content/uploads/2019/07/AMJuly19News-ametek1-e1563205327354-1024x1024.jpg'
    },
    {
      id: 9,
      full_name: 'Julianne K. Roth',
      email: 'JulianneKRoth@armyspy.com',
      used_license: 4,
      checked: false,
      total_license: 20,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2it5gWw0Qri4SmsZO6E6Y_P4BveunzwmjoVrrHzOHOrbF-MKQVg'
    },

  ]
  breadcrumbsArray: any = [
    "manager-client-list",
    "manager-users-site-group",
    "manager-group-list"
  ];

  public selectValueArr = [];

  constructor(public router: Router, private activeRoute: ActivatedRoute, public dialog: MatDialog) {
    this.clientList;
    activeRoute.queryParams.subscribe(params => {
      this.pid = params['pid'];
      if (this.pid) {
        this.showList = true;
        this.emptyMsg = false;
      } else {
        this.showList = false;
        this.emptyMsg = true;
      }
    });
  }

  async goToVisit(client_name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        clientName: client_name
      }
    };
    this.router.navigate(["manager-users-site-group"], navigationExtras);
  }


  async goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async selectListItem(index: number, userid: number) {
    if (this.selectValueArr.length == 0) {
      this.selectValueArr.push(userid);
      for (var i = 0; i < this.clientList.length; i++) {
        if (this.clientList[i].id === userid) {
          this.clientList[i].checked = true;
        }
      }
    } else {
      for (var i = 0; i < this.selectValueArr.length; i++) {
        if (this.selectValueArr[i] === userid) {
          this.selectValueArr.splice(i, 1);
          for (var i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].id === userid) {
              this.clientList[i].checked = false;
            }
          }
        } else {
          this.selectValueArr.push(userid);
          for (var i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].id === userid) {
              this.clientList[i].checked = true;
            }
          }
        }
      }
    }
  }

  ngOnInit() { }

  async addClients() {
    this.router.navigate(['/add-client']);
  }

  async editGroup() {
    const navigationExtras = {
      queryParams: {
        pid: true,
        pageRef: 'edit-group'
      }
    };
    this.router.navigate(['/manager-add-group'], navigationExtras);
  }


  async showLicense() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: "adminLicense",
      }
    });
  }
}
